export const config = {
    sorting: [
        {
            label: 'MEDIA.NAME',
            value: 'title',
            order: 'asc',
            icon: 'sort_by_alpha',
        },
        {
            label: 'MEDIA.UPLOAD_DATE',
            value: 'model.created_at',
            order: 'asc',
            icon: 'access_time',
        },
    ],
};
